import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/companies`;

const adminNav = [{
  name: "admin-users", iconPath: "mdiAccountGroup", label: "nav.users",
}, {
  name: "admin-keys", iconPath: "mdiKey", label: "nav.adminKeys",
}, {
  name: "sav", iconClass: "icon-picto_sav", label: "nav.sav",
}, {
  name: "admin-logs", iconClass: "icon-picto_historique", label: "nav.historical",
}, {
  name: "companies", iconClass: "icon-picto_company", label: "nav.companies",
}, {
  name: "admin-buildings", iconLabel: "domain", label: "nav.buildings",
}, {
  name: "admin-relays", iconPath: "mdiStore", label: "nav.allRelays",
}, {
  name: "admin-blockchain", iconClass: "icon-picto_receipt", label: "nav.blockchain",
}, {
  name: "admin-api-queries", iconLabel: "search", label: "nav.apiQueries",
}, {
  name: "admin-administration", iconClass: "icon-picto_mon-compte", label: "nav.administration",
}, {
  name: "sql", iconLabel: "search", label: "nav.SQL",
}];

const state = {
  defaultNavItemList: null, mobileNavItemList: null, envCompanyId: null,
};

const getters = {
  getDefaultNavItemList: (state) => state.defaultNavItemList || [],
  getMobileNavItemList: (state) => state.mobileNavItemList || [],
  isNavFetched: (state): boolean => !!state.defaultNavItemList || !!state.mobileNavItemList,
};

const mutations = {
  setDefaultNavItemList(state, defaultNavItemList) {
    state.defaultNavItemList = defaultNavItemList;
  },
  setMobileNavItemList(state, mobileNavItemList) {
    state.mobileNavItemList = mobileNavItemList;
  },
  reset(state) {
    state.defaultNavItemList = null;
    state.mobileNavItemList = null;
    state.envCompanyId = null;
  },
};

const actions = {
  fetchNavItemList({ rootGetters, dispatch }) {
    return rootGetters.isMobile ? dispatch("fetchMobileNavItemList") : dispatch("fetchDefaultNavItemList");
  },
  fetchDefaultNavItemList({ commit, state, rootGetters }) {
    const envCompanyId = rootGetters.envCompanyId;
    if (rootGetters.isAdmin) {
      commit("setDefaultNavItemList", adminNav);
    } else if (!envCompanyId) {
      // tslint:disable-next-line:no-console
      console.error("fetchDefaultNavItemList error : no envCompanyId");
    } else {
      if (envCompanyId !== state.envCompanyId) {
        commit("reset");
      }
      return state.defaultNavItemList ? state.defaultNavItemList : axiosInstance.get(`${baseUrl}/${envCompanyId}/my-nav/default`)
        .then((data) => data.data)
        .then((data) => commit("setDefaultNavItemList", data));
    }
  },
  fetchMobileNavItemList({ commit, state, rootGetters }) {
    const envCompanyId = rootGetters.envCompanyId;
    if (rootGetters.isAdmin) {
      commit("setMobileNavItemList", adminNav.slice(0, 4));
    } else if (!envCompanyId) {
      // tslint:disable-next-line:no-console
      console.error("fetchMobileNavItemList error : no envCompanyId");
    } else {
      if (envCompanyId !== state.envCompanyId) {
        commit("reset");
      }
      return state.mobileNavItemList ? state.mobileNavItemList : axiosInstance.get(`${baseUrl}/${envCompanyId}/my-nav/mobile`)
        .then((data) => data.data)
        .then((data) => commit("setMobileNavItemList", data));
    }
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
